import React from "react";
import { Box } from "@chakra-ui/react";

const AboutKT = ({ content }) => {
  return <Box>{content}</Box>;
};

export default AboutKT;
